import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=295195b8"
import script from "./AppDownload.vue?vue&type=script&lang=ts"
export * from "./AppDownload.vue?vue&type=script&lang=ts"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=295195b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports